import React from "react";

export const StatCard = ({ label, value, sub, icon: Icon, accent = "brand", testId, delay = 0 }) => {
  const tones = {
    brand: "from-brand-600 to-brand-500 text-white",
    cyan: "from-cyanx to-brand-500 text-white",
    green: "from-emerald-500 to-teal-500 text-white",
    slate: "from-slate-700 to-slate-500 text-white",
  };
  return (
    <div
      className="clay clay-hover p-6 animate-fade-up"
      style={{ animationDelay: `${delay}ms` }}
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="label-xs">{label}</p>
          <p className="mt-3 font-display text-3xl font-semibold text-slate-900 truncate">{value}</p>
          {sub && <p className="mt-1.5 text-sm text-slate-500 truncate">{sub}</p>}
        </div>
        {Icon && (
          <div className={`shrink-0 grid place-items-center h-11 w-11 rounded-xl bg-gradient-to-br ${tones[accent]}`}>
            <Icon size={19} strokeWidth={2.2} />
          </div>
        )}
      </div>
    </div>
  );
};

export const SectionHead = ({ title, sub, right }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      <h2 className="font-display text-2xl font-semibold tracking-tight text-slate-900">{title}</h2>
      {sub && <p className="mt-1 text-sm text-slate-500">{sub}</p>}
    </div>
    {right}
  </div>
);

export const Empty = ({ icon: Icon, title, sub, action }) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
    {Icon && (
      <div className="grid place-items-center h-14 w-14 rounded-2xl bg-brand-50 text-brand-600 mb-5">
        <Icon size={24} />
      </div>
    )}
    <h3 className="font-display text-lg font-semibold text-slate-800">{title}</h3>
    {sub && <p className="mt-2 max-w-md text-sm text-slate-500">{sub}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);

export const ConfBadge = ({ value, label }) => {
  const v = value || 0;
  const tone = v >= 0.9 ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : v >= 0.7 ? "bg-blue-50 text-brand-700 border-blue-200"
    : "bg-amber-50 text-amber-700 border-amber-200";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 font-mono text-[11px] font-medium ${tone}`}>
      {label}{(v * 100).toFixed(1)}%
    </span>
  );
};

export const StatusPill = ({ status }) => {
  const map = {
    scheduled: ["Terjadwal", "bg-slate-100 text-slate-700 border-slate-200"],
    live: ["Live", "bg-red-50 text-red-600 border-red-200"],
    processing: ["Diproses", "bg-amber-50 text-amber-700 border-amber-200"],
    completed: ["Selesai", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    cancelled: ["Dibatalkan", "bg-slate-100 text-slate-500 border-slate-200"],
    open: ["Open", "bg-slate-100 text-slate-700 border-slate-200"],
    in_progress: ["Berjalan", "bg-blue-50 text-brand-700 border-blue-200"],
    done: ["Selesai", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    high: ["Tinggi", "bg-red-50 text-red-600 border-red-200"],
    medium: ["Sedang", "bg-amber-50 text-amber-700 border-amber-200"],
    low: ["Rendah", "bg-slate-100 text-slate-600 border-slate-200"],
  };
  const [text, cls] = map[status] || [status, "bg-slate-100 text-slate-600 border-slate-200"];
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${cls}`}>
      {status === "live" && <span className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" />}
      {text}
    </span>
  );
};

export const Skeletons = ({ rows = 4, className = "h-24" }) => (
  <div className="grid gap-4">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className={`animate-pulse rounded-2xl bg-slate-200/70 ${className}`} />
    ))}
  </div>
);
